enum MailboxLoadStateEnum {
    Uninitialized,
    Loading,
    Loaded,
    ErrorLoading,
}

export default MailboxLoadStateEnum;
